'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACT',
    link: '/contact'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Travel & Expense',
      src: '/travel-expense'
    }, {
      text: 'Expense',
      src: '/expense-management'
    }, {
      text: 'Budget',
      src: '/budget-management'
    }, {
      text: 'Travel',
      src: '/products/travel-management'
    }, {
      text: 'Invoice',
      src: '/invoice-management'
    }, {
      text: 'Intelligence',
      src: '/business-intelligence'
    }, {
      text: 'Locate',
      src: '/concur-locate'
    }, {
      text: 'Request a Quote',
      src: '/get-quote-form',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'FEATURES'
    },
    list: [{
      text: 'Travel Request',
      src: '/products/travel-request'
    }, {
      text: 'Mobility',
      src: '/product/mobile'
    }, {
      text: 'TripIt',
      src: '/products/tripit'
    }, {
      text: 'Services',
      src: '/product/services'
    }, {
      text: 'Visibility',
      src: '/visibility'
    }, {
      text: 'SAP Integration',
      src: '/sap-integration'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'Why Concur',
      src: '/why-concur'
    }, {
      text: 'Platform',
      src: '/concur-integrated-ecosystem'
    }, {
      text: 'About SAP Concur',
      src: '/about'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'Office Locations',
      src: '/contact/offices'
    }, {
      text: 'Careers',
      src: ''
    }, {
      text: 'Contact Sales',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Newsroom',
      src: '/newsroom'
    }, {
      text: 'Press Release',
      src: '/media-resources/press-releases'
    }, {
      text: 'Events',
      src: '/newsroom/c/upcoming-events-event-memories'
    }, {
      text: 'Resource Library',
      src: '/resource-centre'
    }, {
      text: 'Case Studies',
      src: '/casestudy'
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }, {
      text: 'Concur Expense Demo',
      src: '/self-guided-demo-expense-en-hk#/',
      classes: 'call-out'
    }, {
      text: 'Concur Invoice Demo',
      src: '/self-guided-demo-invoice-en-hk#/',
      classes: 'call-out'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR BLOG',
    href: ''
  }, {
    text: 'CONTACT',
    href: '/contact'
  }, {
    text: '+852 3899 8624',
    href: '/contact/offices'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};